import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import * as styles from './styles'

const MobileBeneficiaryFiltersComponent = ({ activeTab, categories, onTabChange }) => {
	// Create tabs array including All and Favorite
	const tabs = [
		{ id: 'all', label: 'All' },
		{ id: 'favorite', label: 'Favorite' },
		...categories.map((category) => ({
			id: category.description.toLowerCase(),
			label: category.description,
		})),
	]

	return (
		<div css={styles.container}>
			<div css={styles.filtersWrapper}>
				{tabs.map((tab) => {
					const isSelected = activeTab === tab.id

					return (
						<button
							key={tab.id}
							css={[styles.filterPill, isSelected && styles.filterPillActive]}
							onClick={() => onTabChange(tab.id)}
							type="button"
						>
							<Text
								size={12}
								medium
								css={[styles.filterText, isSelected && styles.filterTextActive]}
							>
								{tab.label}
							</Text>
						</button>
					)
				})}
			</div>
		</div>
	)
}

MobileBeneficiaryFiltersComponent.propTypes = {
	activeTab: PropTypes.string.isRequired,
	categories: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string.isRequired,
	})).isRequired,
	onTabChange: PropTypes.func.isRequired,
}

export default MobileBeneficiaryFiltersComponent 